// src/components/NavBar.js
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import MobileMenu from "./MobileMenu";
// import { ChevronDown } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "./ui/navigation-menu";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Toast, ToastDescription, ToastTitle, ToastViewport } from "./ui/toast";
// import { ShoppingCart } from "lucide-react";
// import { useCart } from "../context/CartContext";
import { useUserType } from "../context/UserTypeContext";

const NavBar = () => {
  // const { cartCount } = useCart();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const { userSession, logout } = useAuth(); // Get session and logout from context
  const location = useLocation(); // Hook to get the current route
  const [toastList, setToastList] = useState([]); // Manage toasts

  const { setUserType } = useUserType();

  const [open, setOpen] = useState({
    marketing: false,
    specifications: false,
    equipment: false,

    resiline320: false,
    guides: false,
    nsfcertificate: false,
    pfas: false,
    sds: false,
    technicaldata: false,
    testreports: false,

    resiline330: false,
    r330: false,

    resiline325: false,
  });

  const toggle = (section) => {
    setOpen((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const role = userSession?.role;
  // const userToken = userSession?.apiToken;

  // console.log(userToken)

  // console.log(userType);

  // const userType = userSession?.userType;

  useEffect(() => {
    const handleScroll = () => {
      // Change this value (e.g., 50) to control when the blur effect applies
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // const handleProtectedRoute = (path) => {
  //   if (userSession) {
  //     navigate(path);
  //   } else {
  //     navigate("/signin");
  //   }
  // };

  // const handleAddToCart = () => {
  //   // Function to simulate adding items to the cart
  //   setCartCount((prevCount) => prevCount + 1);
  // };

  const closeAllDropdowns = () => {
    setOpen({});
  };

  const handlePdfClick = (url) => {
    window.open(url, "_blank");
    closeAllDropdowns();
  };

  const handleClick = (requiredUserType, path) => {
    if (userSession?.userType !== requiredUserType) {
      const message =
        requiredUserType === "applicator"
          ? "You need to Sign in as an APPLICATOR"
          : "You need to Sign in as a CUSTOMER";

      setToastList((prev) => [
        ...prev,
        {
          id: Date.now(),
          title: "Access Denied",
          description: message,
          variant: "destructive",
        },
      ]);
      return;
    }
    closeAllDropdowns();
    navigate(path);
  };

  const removeToast = (id) => {
    setToastList((prev) => prev.filter((toast) => toast.id !== id));
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-50 transition-all duration-300 ${
        isScrolled ? "tw-bg-[#1e1e1e] tw-shadow-lg" : "tw-bg-[#1e1e1e]"
      }`}
      aria-label="Main Navigation"
    >
      <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-flex tw-items-center tw-justify-between tw-h-20 sm:tw-h-24">
        <div className="tw-flex-shrink-0">
          <Link to="/" aria-label="Home">
            <img
              src="/elogo.png" // Replace with your actual logo path
              alt="Logo"
              className="tw-h-8 sm:tw-h-10 md:tw-h-12 lg:tw-h-14"
            />
          </Link>
        </div>

        {/* CENTRE: Nav Links */}
        <div className="tw-hidden md:tw-flex tw-ml-6 tw-space-x-4 lg:tw-space-x-6">
          <NavigationMenu className="">
            <NavigationMenuList>
              {/* Home */}
              <NavigationMenuItem>
                <NavigationMenuLink
                  asChild
                  className={navigationMenuTriggerStyle()}
                >
                  <Link
                    to="/"
                    className={`tw-text-base tw-font-normal ${
                      isActive("/")
                        ? "tw-text-[#00B5ED] tw-font-bold"
                        : "tw-text-white"
                    } hover:tw-text-[#00B5ED]`}
                  >
                    Home
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>

              {/* <NavigationMenuItem>
                <NavigationMenuLink
                  asChild
                  className={navigationMenuTriggerStyle()}
                >
                  <Link
                    to="/contactus"
                    className={`tw-text-sm tw-font-medium ${
                      isActive("/")
                        ? "tw-text-[#00B5ED] tw-font-bold"
                        : "tw-text-white"
                    } hover:tw-text-[#00B5ED]`}
                  >
                    Contact Us
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem> */}
            </NavigationMenuList>
          </NavigationMenu>

          {/* Portals Dropdown */}
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="tw-font-normal">
                  Portals
                </NavigationMenuTrigger>
                <NavigationMenuContent className="tw-bg-[#1e1e1e] tw-p-4">
                  <Button
                    variant="mobilemenu"
                    onClick={() => handleClick("applicator", "/projectlist")}
                    className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED]"
                  >
                    Applicator
                  </Button>
                  <Button
                    variant="mobilemenu"
                    onClick={() => handleClick("customer", "/projectinfo")}
                    className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED]"
                  >
                    Customer
                  </Button>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>

          {/* Product Information Dropdown */}
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="tw-font-normal">
                  Product Information
                </NavigationMenuTrigger>
                <NavigationMenuContent className="tw-bg-[#1e1e1e] tw-p-4">
                  {/* Resiline 320 */}
                  <div>
                    <button
                      onClick={() => toggle("resiline320")}
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Resiline 320
                    </button>
                    {open.resiline320 && (
                      <div className="tw-mx-2 tw-flex tw-flex-col tw-text-center tw-text-sm tw-mt-0 tw-border tw-border-[#00B5ED]/30 tw-rounded-md tw-p-3 tw-bg-white/5">
                        <button
                          onClick={() => toggle("guides")}
                          className="tw-block tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Guides
                        </button>
                        {open.guides && (
                          <div className="tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() => handlePdfClick("/r320use.pdf")}
                              className="tw-mt-2 tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resiline Use.pdf
                            </div>

                            <div
                              onClick={() =>
                                handlePdfClick("/r320guidance.pdf")
                              }
                              className="tw-mt-2 tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resiline Guidance.pdf
                            </div>
                          </div>
                        )}
                        <button
                          onClick={() => toggle("nsfcertificate")}
                          className="tw-block tw-mt-2 tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          NSF Certificate
                        </button>
                        {open.nsfcertificate && (
                          <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() =>
                                handlePdfClick("/nsfcertificate.pdf")
                              }
                              className="tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              NSF-ANSI-CAN Certificate.pdf
                            </div>
                          </div>
                        )}

                        <button
                          onClick={() => toggle("pfas")}
                          className="tw-block tw-mt-2 tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          PFAS
                        </button>
                        {open.pfas && (
                          <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() => handlePdfClick("/resimac.pdf")}
                              className="tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resimac PFOS.pdf
                            </div>
                          </div>
                        )}

                        <button
                          onClick={() => toggle("sds")}
                          className="tw-block tw-mt-2 tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          SDS
                        </button>
                        {open.sds && (
                          <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() =>
                                handlePdfClick("/sdsactivator.pdf")
                              }
                              className="tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              SDS Activator.pdf
                            </div>

                            <div
                              onClick={() => handlePdfClick("/sdsbase.pdf")}
                              className="tw-mt-2 tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              SDS Base.pdf
                            </div>
                          </div>
                        )}
                        <button
                          onClick={() => toggle("technicaldata")}
                          className="tw-block tw-mt-2 tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Technical Data Sheet
                        </button>
                        {open.technicaldata && (
                          <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() => handlePdfClick("/r320tds.pdf")}
                              className="tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resiline 320 TDS.pdf
                            </div>
                          </div>
                        )}
                        <button
                          onClick={() => toggle("testreports")}
                          className="tw-block tw-mt-2 tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Test Reports
                        </button>
                        {open.testreports && (
                          <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() =>
                                handlePdfClick("/r320testreport.pdf")
                              }
                              className="tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resiline 320 Report.pdf
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Resiline 330 */}
                  <div>
                    <button
                      onClick={() => toggle("resiline330")}
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Resiline 330
                    </button>
                    {open.resiline330 && (
                      <div className="tw-mx-2 tw-flex tw-flex-col tw-text-center tw-text-sm tw-mt-0 tw-border tw-border-[#00B5ED]/30 tw-rounded-md tw-p-3 tw-bg-white/5">
                        <button
                          onClick={() => toggle("r330")}
                          className="tw-block tw-text-white/80 hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          R330
                        </button>
                        {open.r330 && (
                          <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                            <div
                              onClick={() =>
                                handlePdfClick("/r330casestudy.pdf")
                              }
                              className="tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Case Study.pdf
                            </div>

                            <div
                              onClick={() => handlePdfClick("/r330ifu.pdf")}
                              className="tw-mt-2 tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resiline 330 IFU Issue.pdf
                            </div>

                            <div
                              onClick={() => handlePdfClick("/r330tds.pdf")}
                              className="tw-mt-2 tw-text-sm tw-font-normal tw-cursor-pointer tw-text-white hover:tw-text-[#00B5ED]"
                            >
                              Resiline 330 TDS Issue.pdf
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Resiline 325 */}

                  <div>
                    <button
                      onClick={() => toggle("resiline325")}
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Resiline 325
                    </button>
                    {open.resiline325 && (
                      <div className="tw-mt-2 tw-pl-4 tw-border-l tw-border-white/30 tw-space-y-1">
                        <p className="tw-flex tw-flex-col tw-text-center tw-text-sm tw-mt-0 tw-border tw-border-[#00B5ED]/30 tw-rounded-md tw-p-3 tw-bg-white/5">
                          Coming Soon
                        </p>
                      </div>
                    )}
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>

          {/* Resources Dropdown */}
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="tw-font-normal">
                  Resources
                </NavigationMenuTrigger>
                <NavigationMenuContent className="tw-bg-[#1e1e1e] tw-p-4 tw-w-56">
                  {/* Marketing Material */}
                  <div>
                    <button
                      onClick={() => toggle("marketing")}
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Marketing Material
                    </button>
                    {open.marketing && (
                      <div className="tw-mx-2 tw-text-center tw-text-sm tw-mt-0">
                        <Link
                          to="/"
                          className="tw-block tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Brochure/Pamphlets
                        </Link>
                        <Link
                          to="/"
                          className="tw-block tw-mt-1 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Presentations
                        </Link>
                      </div>
                    )}
                  </div>

                  {/* Specifications */}
                  <div className="tw-mt-1">
                    <button
                      onClick={() => toggle("specifications")}
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Specifications
                    </button>
                    {open.specifications && (
                      <div className="tw-mx-2 tw-text-center tw-text-sm tw-mt-0">
                        <Link
                          to="/"
                          className="tw-block tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Pipe Cleaning
                        </Link>
                        <Link
                          to="/"
                          className="tw-block tw-mt-1 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Pipe Lining
                        </Link>
                      </div>
                    )}
                  </div>

                  {/* Case Studies (no submenu) */}
                  <div className="tw-mt-1">
                    <Link
                      to="/"
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Case Studies
                    </Link>
                  </div>

                  {/* Equipment Information */}
                  <div className="tw-mt-1">
                    <button
                      onClick={() => toggle("equipment")}
                      className="tw-block tw-w-40 tw-text-center tw-py-2 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                    >
                      Equipment Information
                    </button>
                    {open.equipment && (
                      <div className="tw-mx-2 tw-text-center tw-text-sm tw-mt-0">
                        <Link
                          to="/"
                          className="tw-block tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Spray Rig
                        </Link>
                        <Link
                          to="/"
                          className="tw-block tw-mt-1 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Pipe Cleaning
                        </Link>
                        <Link
                          to="/"
                          className="tw-block tw-mt-1 tw-text-white hover:tw-text-[#00B5ED] hover:tw-bg-transparent"
                        >
                          Pipe Disinfection
                        </Link>
                      </div>
                    )}
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        <div className="tw-md:tw-hidden">
          <MobileMenu />
        </div>

        <div className="tw-hidden md:tw-flex tw-items-center tw-space-x-3 lg:tw-space-x-4">
          {/* Admin Button (Only for Admin & Superadmin) */}
          {(role === "admin" || role === "superadmin") && (
            <Button
              className="tw-bg-[#00B5ED] tw-text-sm tw-text-white tw-font-medium tw-px-4 tw-py-2 tw-rounded-md"
              onClick={() =>
                window.open("/admin", "_blank", "noopener,noreferrer")
              } // Open in new tab
            >
              Admin
            </Button>
          )}

          {userSession ? (
            <div className="tw-flex tw-items-center tw-space-x-4">
              <span className="tw-text-white tw-text-sm">
                Welcome,{" "}
                <span className="tw-font-medium">{userSession.firstName}</span>
              </span>
              <Button
                variant="destructive"
                className="tw-text-white tw-text-sm hover:tw-bg-destructive/80 tw-font-medium tw-px-4 tw-py-2 tw-rounded-md"
                onClick={logout}
                aria-label="Log Out"
              >
                Log Out
              </Button>
            </div>
          ) : (
            <>
              {/* <Link to="/register">
                <Button
                  variant="darkbg"
                  className="hover:tw-bg-[#1e1e1e] tw-text-sm"
                  size="lg"
                  aria-label="Applicator Sign in"
                >
                 Applicator Sign up
                </Button>
              </Link> */}

              <Link to="/signin">
                <Button
                  onClick={() => setUserType("applicator")}
                  variant="darkbg"
                  className="hover:tw-bg-[#1e1e1e]"
                  aria-label="Applicator Access"
                >
                  Applicator Sign in
                </Button>
              </Link>

              {/* <Link to="/signin">
                <Button
                  onClick={() => setUserType("customer")}
                  variant="darkbg"
                  className="hover:tw-bg-[#1e1e1e]"
                  aria-label="Non-Applicator Sign in"
                >
                  Non-Applicator Sign in
                </Button>
              </Link> */}
            </>
          )}

          {/* Cart Icon */}
          {/* {userType === "applicator" && (
            <button
              onClick={() => navigate("/checkout")}
              className="tw-relative tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-bg-transparent tw-border-none tw-cursor-pointer"
              aria-label="Cart"
            >
              <ShoppingCart className="tw-text-white" size={24} />
              {cartCount > 0 && (
                <span className="tw-absolute tw-top-0 tw-right-0 tw-bg-[#00B5ED] tw-text-white tw-rounded-full tw-text-xs tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center">
                  {cartCount}
                </span>
              )}
            </button>
          )} */}

          <Link to="/contactus">
            <Button
              variant="darkbg"
              className="hover:tw-bg-[#1e1e1e]"
              aria-label="Contact Us"
            >
              Contact Us
            </Button>
          </Link>

          {/* Add to Cart Button for Testing
          <Button
            variant="darkbg"
            className="tw-hidden" // Hide in production
            onClick={handleAddToCart}
          >
            Add to Cart (Test)
          </Button> */}
        </div>
      </div>

      {/* Toast Notifications */}
      <ToastViewport />
      {toastList.map(({ id, title, description, variant }) => (
        <Toast
          key={id}
          variant={variant}
          open={true}
          duration={Infinity}
          onOpenChange={(isOpen) => {
            if (!isOpen) removeToast(id);
          }}
          className="tw-flex tw-flex-col tw-text-center"
        >
          <ToastTitle>{title}</ToastTitle>
          <ToastDescription>{description}</ToastDescription>

          {/* Close Button */}
          <button
            onClick={() => removeToast(id)}
            className="tw-mt-3 tw-self-center tw-text-sm tw-font-medium tw-bg-white tw-px-2 tw-py-1 tw-text-black hover:tw-bg-white/80"
          >
            Close
          </button>
        </Toast>
      ))}
    </nav>
  );
};

export default NavBar;
